import { render, staticRenderFns } from "./w-text.vue?vue&type=template&id=e8791a88&lang=pug&"
import script from "./w-text.vue?vue&type=script&lang=js&"
export * from "./w-text.vue?vue&type=script&lang=js&"
import style0 from "./w-text.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8791a88')) {
      api.createRecord('e8791a88', component.options)
    } else {
      api.reload('e8791a88', component.options)
    }
    module.hot.accept("./w-text.vue?vue&type=template&id=e8791a88&lang=pug&", function () {
      api.rerender('e8791a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-text.vue"
export default component.exports